import { Switch } from "@xola/ui-kit";
import React, { ReactNode } from "react";

interface SwitchProps {
    isChecked: boolean;
    size?: "medium" | "small" | "large";
    onChange?: (value: boolean) => void;
    className?: string;
    labelClassName?: string;
    isDisabled?: boolean;
    children: string | ReactNode;
    direction?: "left" | "right";
    font?: string;
}

export const SwitchField = ({
    isChecked,
    size = "medium",
    isDisabled = false,
    className,
    direction = "right",
    children,
    onChange,
    labelClassName = "font-normal",
    ...rest
}: SwitchProps) => {
    return (
        <Switch.Group className={className}>
            {direction === "left" && (
                <SwitchLabelText direction={direction} labelClassName={labelClassName}>
                    {children}
                </SwitchLabelText>
            )}
            <Switch isChecked={isChecked} size={size} disabled={isDisabled} onChange={onChange} {...rest} />
            {direction === "right" && (
                <SwitchLabelText direction={direction} labelClassName={labelClassName}>
                    {children}
                </SwitchLabelText>
            )}
        </Switch.Group>
    );
};

const SwitchLabelText = ({
    direction,
    children,
    labelClassName,
}: Pick<SwitchProps, "direction" | "children" | "labelClassName">) => {
    return (
        <Switch.Label direction={direction}>
            <div className={labelClassName}>{children}</div>
        </Switch.Label>
    );
};
